module.exports = {"player_position":"Posizione del giocatore","enemy_position":"Posizione nemica"};